import { formatDiffDate, ignoreTimezone } from "@enkor/date-fns";

import { ResponseEventPreviewReview } from "@models/data-contracts";
import { ReviewCardType } from "@domains/auth/types/reviewTypes";

class ReviewViewModel {
  shouldShowReview: boolean;
  avgRating: string;
  totalCount: number;
  reviewList: ReviewCardType[];

  static create(responseData: ResponseEventPreviewReview) {
    const review = new ReviewViewModel();

    review.shouldShowReview = !!responseData.avgRating;

    review.avgRating = responseData.avgRating.toFixed(1);
    review.totalCount = responseData.totalCount;
    review.reviewList = responseData.list.map((reviewInfo) => ({
      id: reviewInfo.id,
      review: {
        rating: reviewInfo.rating,
        content: reviewInfo?.content || "",
        fileList: reviewInfo.fileList,
        createdAt: formatDiffDate(ignoreTimezone(reviewInfo.createdAt)),
      },
      reviewer: {
        id: reviewInfo.createdUserId,
        nickname: reviewInfo.createdUserName,
        profile: reviewInfo.createdUserUrl,
      },
      event: {
        id: String(reviewInfo.eventId),
        title: reviewInfo.eventTitle,
      },
    }));

    return review;
  }
}

export default ReviewViewModel;
